<template>
    <div>
        <h1 style="font-size: 24px; color: black;">拓展关联媒体配置</h1>
        <el-card shadow="never">
            <el-row type="flex" align="middle">
                <el-col :span="5">
                    <span> 应用名称： </span>
                    <el-select v-model="queryData.appId" filterable  >
                        <el-option :key="-1" label="全部" :value="-1"></el-option>
                        <el-option
                            v-for="(value,key) in appRel"
                            :label="value"
                            :value="Number(key)"
                            :key="Number(key)">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <span> 日期：</span>
                    <el-date-picker
                        v-model="queryData.timeDate"
                        type="daterange"
                        :clearable="false"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']"
                    >
                    </el-date-picker>
                </el-col>
            </el-row>
            <el-row type="flex" align="middle">
                <el-col :span="5">
                    <el-button type="primary" @click="queryList">查询</el-button>
                    <el-button type="primary" @click="showDetails('创建')">创建</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
            <el-form :model="editForm" label-width="150px">
                <el-form-item v-if="dialogTitle === '创建'" label="应用:">
                    <el-select v-model="editForm.id" @change="appChange($event)">
                        <el-option
                            v-for="item in appList"
                            :label="item.appName"
                            :value="item.appId"
                            :key="item.appId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="dialogTitle === '编辑'" label="应用:">
                    <el-select v-model="editForm.id" disabled>
                        <el-option
                            v-for="(value,key) in appRel"
                            :label="value"
                            :value="Number(key)"
                            :key="Number(key)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包名:">
                    <el-input style="width: 300px" type="text" v-model="editForm.packageName" disabled></el-input>
                </el-form-item>
                <el-form-item label="友盟appKey:">
                    <el-input style="width: 300px" type="text" v-model="editForm.appKey"></el-input>
                </el-form-item>
                <el-form-item label="百度appId:">
                    <el-input style="width: 300px" type="text" v-model="editForm.baiduAppId"></el-input>
                </el-form-item>
                <el-form-item label="快手appId:">
                    <el-input style="width: 300px" type="text" v-model="editForm.ksAppId"></el-input>
                </el-form-item>
                <el-form-item label="adScope的appId:">
                    <el-input style="width: 300px" type="text" v-model="editForm.adscopeAppId"></el-input>
                </el-form-item>
                <el-form-item label="oneway的pid:">
                    <el-input style="width: 300px" type="text" v-model="editForm.onewayPid"></el-input>
                </el-form-item>
                <el-form-item label="mtg的appId:">
                    <el-input style="width: 300px" type="text" v-model="editForm.mtgAppId"></el-input>
                </el-form-item>
                <el-form-item label="sigmob的appId:">
                    <el-input style="width: 300px" type="text" v-model="editForm.sigmobAppId"></el-input>
                </el-form-item>
                <el-form-item label="优量汇的appId:">
                    <el-input style="width: 300px" type="text" v-model="editForm.ylhAppId"></el-input>
                </el-form-item>
                <el-form-item label="优推appId:">
                    <el-input style="width: 300px" type="text" v-model="editForm.ytAppId"></el-input>
                </el-form-item>
                <el-form-item label="投放快手siteId:">
                    <el-input style="width: 300px" type="text" v-model="editForm.ksSiteId"></el-input>
                </el-form-item>
                <el-form-item label="匹配近似名称:">
                    <el-input style="width: 300px" type="text" v-model="editForm.likeName"></el-input>
                </el-form-item>
                <el-form-item label="穿山甲回调密钥:">
                    <el-input style="width: 300px" type="text" v-model="editForm.csjAttrCallbackSecret"></el-input>
                </el-form-item>
                <el-form-item label="穿山甲回调url:">
                    <el-input style="width: 300px" type="text" v-model="editForm.csjAttrCallbackUrl"></el-input>
                </el-form-item>
                <el-form-item label="百度apkId:">
                    <el-input style="width: 300px" type="text" v-model="editForm.baiduApkId"></el-input>
                </el-form-item>
                <el-form-item label="领页id:">
                    <el-input style="width: 300px" type="text" v-model="editForm.lyId"></el-input>
                </el-form-item>
                <el-form-item label="美数id:">
                    <el-input style="width: 300px" type="text" v-model="editForm.msId"></el-input>
                </el-form-item>
                <el-form-item label="章鱼id:">
                    <el-input style="width: 300px" type="text" v-model="editForm.zyId"></el-input>
                </el-form-item>
                <el-form-item label="泛为id:">
                    <el-input style="width: 300px" type="text" v-model="editForm.fwId"></el-input>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirm">确 定</el-button>
                    <el-button type="info" @click="cancel">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <h1>
            <el-table border :data="topicList">

                <el-table-column label="应用id" prop="id"></el-table-column>
                <el-table-column label="应用名称" prop="appName"></el-table-column>
                <el-table-column label="友盟appKey" prop="appKey"></el-table-column>
                <el-table-column label="包名" prop="packageName"></el-table-column>
                <el-table-column label="百度appId" prop="baiduAppId"></el-table-column>
                <el-table-column label="快手appId" prop="ksAppId"></el-table-column>
                <el-table-column label="adScope的appId" prop="adscopeAppId"></el-table-column>
                <el-table-column label="oneway的pid" prop="onewayPid"></el-table-column>
                <el-table-column label="mtg的appId" prop="mtgAppId"></el-table-column>
                <el-table-column label="sigmob的appId" prop="sigmobAppId"></el-table-column>
                <el-table-column label="优量汇的appId" prop="ylhAppId"></el-table-column>
                <el-table-column label="优推appId" prop="ytAppId"></el-table-column>
                <el-table-column label="投放快手siteId" prop="ksSiteId"></el-table-column>
                <el-table-column label="匹配近似名称" prop="likeName"></el-table-column>
                <el-table-column label="穿山甲回调密钥" prop="csjAttrCallbackSecret"></el-table-column>
                <el-table-column label="穿山甲回调url" prop="csjAttrCallbackUrl"></el-table-column>
                <el-table-column label="百度apkId" prop="baiduApkId"></el-table-column>
                <el-table-column label="领页id" prop="lyId"></el-table-column>
                <el-table-column label="美数id" prop="msId"></el-table-column>
                <el-table-column label="章鱼id" prop="zyId"></el-table-column>
                <el-table-column label="泛为id" prop="fwId"></el-table-column>
                <el-table-column label="创建时间" prop="createDt" width="160px">
                    <template slot-scope="scope">
                        {{ scope.row.createDt | dateTimeFormat }}
                    </template>
                </el-table-column>
                <!--                <el-table-column  label="更新时间"  prop="updateDt" width="160px"></el-table-column>-->
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="primary" @click="showDetails('编辑',scope.row)">编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[10,20,30,50]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
import {appIdList, updateAppId,} from "@/http/outApi";
import {searchApp} from '@/http/settingApi'
import settingMix from '@/utils/mix/common-setting'
import ArrayUtil from '@/utils/ArrayUtil'

export default {
    name: "AppIdConfig",
    mixins: [settingMix],
    data() {
        return {
            page: {
                size: 20,
                page: 1,
                totalElements: null
            },
            dialogVisible: false,
            dialogTitle: '',
            queryData: {
                appId: -1,
                timeDate: ['', ''],
            },
            editForm: {},
            topicList: [],
            appRel: {},
            appList: [],
        }
    },
    methods: {
        handleSizeChange(size) {
            this.page.size = size;
            this.queryList();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.queryList();
        },
        appChange(appId) {
            var tempObj = null;
            for (let i = 0; i < this.appList.length; i++) {
                // console.log(this.appList[i]);
                if (this.appList[i].appId === appId) {
                    tempObj = this.appList[i];
                    break; //   跳出整个循环
                }
            }
            if (tempObj != null) {
                this.editForm.id = tempObj.appId;
                this.editForm.appName = tempObj.appName;
                this.editForm.packageName = tempObj.packageName;
            }
        },
        showDetails(title, row) {
            this.editForm = {
                "id": null,
                "appName": '',
                "appKey": '',
                "packageName": '',
                "baiduAppId": '',
                "ksAppId": '',
                "adscopeAppId": '',
                "onewayPid": '',
                "mtgAppId": '',
                "sigmobAppId": '',
                "ylhAppId": '',
                "ytAppId": '',
                "ksSiteId": '',
                "createDt": '',
                "likeName": '',
                "updateDt": '',
                "csjAttrCallbackSecret": '',
                "csjAttrCallbackUrl": '',
                "baiduApkId": '',
                "lyId": '',
                "msId": '',
                "zyId": '',
                "fwId": '',
            };
            this.dialogTitle = title;
            this.dialogVisible = true;
            if (row) {
                this.editForm = {
                    "id": row.id,
                    "appName": row.appName,
                    "appKey": row.appKey,
                    "packageName": row.packageName,
                    "baiduAppId": row.baiduAppId,
                    "ksAppId": row.ksAppId,
                    "adscopeAppId": row.adscopeAppId,
                    "mtgAppId": row.mtgAppId,
                    "onewayPid": row.onewayPid,
                    "sigmobAppId": row.sigmobAppId,
                    "ylhAppId": row.ylhAppId,
                    "ytAppId": row.ytAppId,
                    "ksSiteId": row.ksSiteId,
                    "likeName": row.likeName,
                    "createDt": row.createDt,
                    "updateDt": row.updateDt,
                    "csjAttrCallbackSecret": row.csjAttrCallbackSecret,
                    "csjAttrCallbackUrl": row.csjAttrCallbackUrl,
                    "baiduApkId": row.baiduApkId,
                    "lyId": row.lyId,
                    "msId": row.msId,
                    "zyId": row.zyId,
                    "fwId": row.fwId,
                };
            }
        },
        confirm() {
            updateAppId(this.editForm).then(resp => {
                if (resp.data.status === 0) {
                    this.dialogVisible = false;
                    this.queryList();
                }
            })
        },
        cancel() {
            this.dialogVisible = false;
        },
        queryList() {
            let queryTrueData = {appId: this.queryData.appId};
            queryTrueData.startDt = this.queryData.timeDate[0] === '' ? null : this.queryData.timeDate[0];
            queryTrueData.endDt = this.queryData.timeDate[1] === '' ? null : this.queryData.timeDate[1];
            queryTrueData = Object.assign(queryTrueData, this.page)
            appIdList(queryTrueData).then(resp => {
                if (resp.data.status === 0) {
                    this.topicList = resp.data.info.content;
                    this.page.totalElements = resp.data.info.total;
                    this.getAppRelTrans()
                }
            })

        },
        getAppRelTrans() {
            let queryTrueData = {appId: -1, size: 9999, page: 1, startDt: null, endDt: null}
            appIdList(queryTrueData).then(resp => {
                if (resp.data.status === 0) {
                    this.appRel = ArrayUtil.transferList2Obj(resp.data.info.content, 'id', 'appName')
                    let req = {dept: -1, state: -1, order: 'descending', prop: 'app_id', size: 9999, page: 1}
                    searchApp(req).then(resp => {
                        let tempList = []
                        resp.data.info.content.forEach(it => {
                            // if (!this.appRel.hasOwnProperty(it.appId)) {
                            if (!Object.prototype.hasOwnProperty.call(this.appRel, it.appId)) {
                                tempList.push(it)
                            }
                        })
                        this.appList = tempList
                    })
                }
            })
        }
    },
    created() {
        this.queryList();
        this.getAppRelTrans();
    },
}
</script>

<style scoped>

</style>
